<script setup lang="ts">
import type {MenuItemInterface} from "~~/server/types/menu";

defineProps<{
    item: MenuItemInterface;
    idx: number;
}>();
</script>

<template>
    <div class="panel panel-full panel--mega_with_sub_categories1" :id="`panel-${idx}`" role="menu">
        <div class="panel-header">
            <div class="panel-title">{{ item.name }}</div>
            <NuxtLinkLocale :to="item.url" class="panel-view_all">
              {{$t('view_all')}} <span aria-hidden="true">→</span>
            </NuxtLinkLocale>
        </div>

        <div class="panel-items">
            <div v-for="(col, ck) in item.children" :key="ck" class="item">
                <div class="level_1">
                    <NuxtLinkLocale :to="col.url" class="title">{{ col.name }}</NuxtLinkLocale>
                    <img :src="col.icon" :alt="col.name" class="image" loading="lazy" style="object-fit: contain;" />
                </div>

                <ul class="level_2">
                    <li v-for="(inner, ik) in col.children || []" :key="ik">
                        <NuxtLinkLocale :to="inner.url" class="title">• {{ inner.name }}</NuxtLinkLocale>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.panel--mega_with_sub_categories1 {
  .panel-items {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 18px;

    @media screen and (max-width: 1100px) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    @media screen and (max-width: 992px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  .item .level_1 .title {
    font: 800 0.95rem/1.1 system-ui, sans-serif;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .level_2 .title {
    font-size: var(--fs--11);
  }
}
</style>
